<template>
  <div class="tile-preview-container">
    <div class="tile-promo-display-selections-div">
      <div class="tile-promo-display-selections-opt">
        <button
          class="tab"
          :class="{ active: viewTypeTab === 'mobilewebViewTab' }"
          @click="$emit('clickTab', 'mobilewebViewTab')"
        >
          Mobile
        </button>
        <button
          class="tab"
          :class="{ active: viewTypeTab === 'desktopViewTab' }"
          @click="$emit('clickTab', 'desktopViewTab')"
        >
          Tablet
        </button>
      </div>
      <div class="tab-selector mr-4">
        <RfLiquidPreview
          v-if="liquidContextStore.isLiquidPushEnabled"
          v-model:userData="liquidContextStore.previewUserContext"
          :appId="appsStore.app?.id"
        />
        <v-select
          v-model="previewDevice"
          :items="[
            { title: 'iOS Preview', value: 'ios' },
            { title: 'Android Preview', value: 'android' },
          ]"
          variant="plain"
          placeholder="Preview"
          class="text-white [&_.v-field\_\_append-inner]:py-0! [&_.v-field\_\_input]:py-0! [&_.v-icon.v-icon]:self-center! [&_.v-icon.v-icon]:text-white! [&_.v-select\_\_selection-text]:mb-0!"
          persistentPlaceholder
        />
      </div>
    </div>
    <v-tabs-window :modelValue="viewTypeTab" class="cursor-not-allowed">
      <v-window-item :transition="false" :reverseTransition="false" value="desktopViewTab">
        <div class="flex items-center justify-center py-2">
          <div
            class="border-grey-1 relative inline-block w-136 overflow-hidden rounded-xl border-5 border-solid"
            :style="zoomStyle"
          >
            <img src="../../../assets/images/push_tablet.png" class="block" />

            <RfRetentionPushContent
              class="absolute left-1/2 w-2/3 -translate-x-1/2"
              :title="parsedRetentionTitle"
              :message="parsedRetentionMessage"
              :image="image"
              :type="previewDevice"
              style="bottom: 4%"
            />
          </div>
        </div>
      </v-window-item>
      <v-window-item :transition="false" :reverseTransition="false" value="mobilewebViewTab">
        <div class="flex items-center justify-center py-2">
          <div
            class="border-grey-1 relative inline-block overflow-hidden rounded-xl border-5 border-solid"
          >
            <img src="../../../assets/images/push_mobile.png" class="block" />
            <RfRetentionPushContent
              class="absolute left-1/2 w-11/12 -translate-x-1/2"
              :title="parsedRetentionTitle"
              :message="parsedRetentionMessage"
              :image="image"
              :type="previewDevice"
              style="bottom: 3%"
            />
          </div>
        </div>
      </v-window-item>
    </v-tabs-window>
  </div>
</template>

<script>
import ZoomPreviewMixin from "@/utils/ZoomPreviewMixin";
import RfRetentionPushContent from "./RfRetentionPushContent.vue";
import { useAppsStore } from "@/pinia/appsStore";
import RfLiquidPreview from "../RfRetentionDevices/RfLiquidPreview.vue";
import { useLiquidContextStore } from "@/pinia/liquidContextStore";

export default {
  name: "RfRetentionPush",
  components: { RfRetentionPushContent, RfLiquidPreview },
  mixins: [ZoomPreviewMixin],
  props: ["actions", "viewTypeTab", "model"],
  setup: () => ({ appsStore: useAppsStore(), liquidContextStore: useLiquidContextStore() }),
  data: () => ({ previewDevice: "ios" }),
  computed: {
    parsedRetentionTitle() {
      return this.liquidContextStore.liquidify(this.actions?.rf_retention_title, true);
    },
    parsedRetentionMessage() {
      return this.liquidContextStore.liquidify(this.actions?.rf_retention_message, true);
    },
    image() {
      if (this.actions.rf_settings_bg_image_is_url === "true")
        return this.previewDevice === "ios"
          ? this.actions.rf_push_ios_image_url
          : this.actions.rf_settings_bg_image_url;
      return this.previewDevice === "ios"
        ? this.actions.rf_push_ios_image
        : this.actions.rf_settings_bg_image;
    },
  },
};
</script>
